import type {RouteClaim, ShellLocation} from '@wandb/forge-shell-contract';

import {remotePathname, shellPathname} from './routeClaims';

/** The location a remote sees for a shell URL its routeClaim matched. */
export function remoteLocation(
  routeClaim: RouteClaim,
  pathname: string,
  search: string,
  hash: string,
  state: unknown
): ShellLocation {
  return {pathname: remotePathname(routeClaim, pathname), search, hash, state};
}

/** The canonical shell URL for a remote path, which may carry search and hash. */
export function shellPath(
  routeClaims: readonly RouteClaim[],
  to: string
): string {
  const url = new URL(to, 'https://shell.invalid');
  const pathname = url.pathname.startsWith('/')
    ? url.pathname
    : `/${url.pathname}`;
  return `${shellPathname(routeClaims, pathname)}${url.search}${url.hash}`;
}
